import { TableColumnKey, TableKey } from './extraction-models/extraction-models';

export type ById<T> = Partial<Record<string, T>>;

export type ExtractedValue = string | number | null;
export type ExtractedValuesByKey = Record<string, ExtractedValue>;
export type ExtractedTablesByKey = Record<TableKey, ExtractedRow[]>;

export type ExtractedDataSnapshot = {
  fields: ExtractedValuesByKey;
  tables: ExtractedTablesByKey;
};

/**
 * A row can belong to neither an overlay-table nor a document if the table-view
 * it was created from was not associated with a document, like it is the case
 * in the consolidation view.
 */
export type RowMembership = TableReference | { documentId: string } | undefined;

export const isTableReference = (rowMembership: RowMembership): rowMembership is TableReference => {
  return !!(rowMembership as TableReference).tableId;
};

export interface TableReference {
  tableId: string;

  /**
   * If this row is created by an overlay table, this value holds the original
   * row index of the created table.
   * This allows us to relate this row to the correct overlay table row even if
   * modifiable rows in the "edit table" where changed or removed afterward.
   */
  originalTableRowIndex?: number;
}

export interface ExtractedTableCell {
  value: ExtractedValue;
  id: string;
}

export interface ExtractedRow {
  rowData: Record<TableColumnKey, ExtractedTableCell>;
  class?: string;
  rowMembership: RowMembership;
}
